class OaklenFaq extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.allowMultiple = this.dataset.allowMultiple === 'true';
    this.items = Array.from(this.querySelectorAll('[data-oaklen-faq-item]'));

    this.items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (this.allowMultiple || !item.open) return;

        this.items.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.open = false;
          }
        });
      });
    });
  }
}

if (!customElements.get('oaklen-faq')) {
  customElements.define('oaklen-faq', OaklenFaq);
}
